import { clinicApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreate } from "@components";
import { PATH_ADD_CLINIC, PATH_CLINIC } from "@configs";
import { IClinic } from "@interfaces";

import { setLoading } from "@redux";
import { useNotify } from "@utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { ClinicForm } from "../../Modules/clinic/Form";

export const PageCreateClinic = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { error } = useNotify();
  const { t } = useTranslation();
  const [clinic, setClinic] = useState<IClinic>();
  useEffect(() => {
    if (id) {
      fetchAdmin();
    }
  }, [id]);
  const data = [
    {
      title: <a href={PATH_CLINIC || ""}>Clinic</a>,
    },
    {
      title: <a href={PATH_ADD_CLINIC || ""}>Add Admin</a>,
    },
  ];
  const fetchAdmin = async () => {
    try {
      dispatch(setLoading(true));
      const res = await clinicApi.clinic(id);
      setClinic(res.data);
    } catch (err: any) {
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.add_clinic")} />
      <StyledCreate>
        <ComponentBread pages={data} />
        <ClinicForm clinic={clinic} />
      </StyledCreate>
    </>
  );
};
